import { useState, memo } from 'react';
import { IImages } from '../../mechanics/characters/Character';
import { uiSlice } from '../../store/reducers/uiReducer';
import { useAppDispatch } from '../../store/store';
import ImgWithFallback from '../ui/ImgWithFallback';
import ToolTip from '../ui/ToolTip';

interface ICharacterRaceProps {
    CharacterRace: IImages
    switchRace: (key: any) => void
    activeClassName: string,
    tip: string
}

const CreateCharacterRaceItem = ({ CharacterRace, switchRace, activeClassName, tip }: ICharacterRaceProps) => {
    const dispatch = useAppDispatch()
    const { setToolTipContent } = uiSlice.actions
    const [toolTip, setToolTip] = useState(false)

    const className = `create-character__race-variable ${activeClassName}`

    function callToolTip(tipType: string) {
        setToolTip(true)
        dispatch(setToolTipContent(tipType))
    }

    return (
        <div className={className} onClick={switchRace} onMouseEnter={() => callToolTip(tip)} onMouseLeave={() => setToolTip(false)}>
            <ImgWithFallback
                src={CharacterRace.webp}
                fallbackSrc={CharacterRace.img} />
            {toolTip ? <ToolTip position='bottom' text={tip} /> : null}
        </div>
    );
};

export default memo(CreateCharacterRaceItem);